import { Component, OnInit, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { CheckboxComponent } from '../../../../shared/components/checkbox/checkbox.component';
import { AuthService } from '../../../../_services/auth.service';

@Component({
  selector: 'app-email-confirmed',
  imports: [CommonModule, ButtonComponent, CheckboxComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './email-confirmed.component.html',
  styleUrl: './email-confirmed.component.css',
})
export class EmailConfirmedComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  passwordToken: string = '';
  showPassword = false;
  showConfirmPassword = false;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.passwordToken = params['token'];
      if (!this.passwordToken) {
        this.errorMessage = 'Password reset token not found. Please try the email verification process again.';
      }
    });

    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
      termsAccepted: [false, Validators.requiredTrue]
    }, { validator: this.passwordMatchValidator });
  }

  // Custom validator to check if passwords match
  passwordMatchValidator(g: FormGroup) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null : { 'mismatch': true };
  }

  onSubmit(): void {
    if (this.resetPasswordForm.invalid) {
      this.errorMessage = 'Please ensure passwords match, are at least 6 characters long, and you have accepted the terms and conditions.';
      return;
    }
    this.errorMessage = '';

    const { password } = this.resetPasswordForm.value;
    const payload = {
      token: this.passwordToken,
      newPassword: password
    };

    this.authService.resetPassword(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.successMessage = 'Password updated successfully! Redirecting to login...';
          setTimeout(() => {
            this.router.navigate(['/auth/login']);
          }, 2000);
        },
        error: (err) => {
          this.errorMessage = err.error?.message || 'An error occurred while resetting your password. Please try again.';
        }
      });
  }
}

